import React from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Modal } from '../Modal';
import { Button } from '../Button';
import styles from './InfoModal.css';

const cx = classnames.bind(styles);

function InfoModal({ isOpen, onCloseModal, title, renderButtons, className, children }) {
    const { t } = useTranslation();

    if (!isOpen) {
        return null;
    }

    if (!title) {
        return null;
    }

    return (
        <Modal
            onCloseModal={onCloseModal}
            className={cx('modal', className)}
        >
            <div className={styles.content}>
                <div className={styles.header}>
                    <p className={styles.title}>
                        {title}
                    </p>
                    <Button
                        iconLeft={{
                            name: 'close'
                        }}
                        type='secondary'
                        onClick={onCloseModal}
                        size='small'
                    />
                </div>
                <div className={styles.main}>
                    {children}
                </div>
                <div className={styles.footer}>
                    {renderButtons
                        ? renderButtons()
                        : (
                            <Button
                                onClick={onCloseModal}
                                className={styles.button}
                                label={t('common.close')}
                                size='medium'
                            />
                        )
                    }
                </div>
            </div>
        </Modal>
    );
}

InfoModal.defaultProps = {
    title: '',
    renderButtons: null
};

InfoModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onCloseModal: PropTypes.func.isRequired,
    title: PropTypes.string,
    renderButtons: PropTypes.func,
    children: PropTypes.any.isRequired
};

export {
    InfoModal
};
